import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_5 = { class: "flex justify-between items-center mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg" }, "Are you sure you want to add this originator?", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "We already have an originator from the same lender in your shortlist.")
], -1)
const _hoisted_8 = { class: "mt-6 flex" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-sky text-white text-sm px-4 py-2 rounded-md"
}, " Yes ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full p-6",
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateOriginatorsList && _ctx.updateOriginatorsList(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("button", {
              type: "button",
              class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalSameLender')))
            }, [
              _createVNode(_component_XIcon, { class: "w-5 h-5" })
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              type: "button",
              class: "bg-white border text-sm px-4 py-2 rounded-md ml-2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal('ModalSameLender')))
            }, " No ")
          ])
        ], 32)
      ])
    ])
  ]))
}